<template>
  <div class="TranscriptSettings">

    <label>
      <span>Background</span>
      <input type="color" v-model="settings.background" />
    </label>

    <label>
      <span>Text</span>
      <input type="color" v-model="settings.color" />
    </label>

    <label>
      <span>Font size</span>
      <input type="range" min="12" max="50" v-model="settings.size"/>
    </label>

    <label>
      <span>Show captions only</span>
      <input type="checkbox" v-model="settings.captionsOnly"/>
    </label>

  </div>
</template>

<script>

//import { mapState } from 'vuex'

export default {
  name: 'TranscriptSettings',
  components: {
    //Component
  },
  data: function () {
    return {
    }
  },
  props: {
  },
  computed: {
    settings: {
      get () { return this.$store.state.room.transcriptSettings},
      set () {
        //this.$store.commit('room/setTranscriptSettings',{transcriptSettings: value})
      }
    },
  },
  methods: {
  },
  mounted: function () {
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">

.TranscriptSettings{
  flex: 1;
  justify-content: center;
  display: flex;
}

.TranscriptSettings > * {
  margin: 0 5px 0 5px;
}

input {
  max-width: 5em;
}

</style>
